
export const ENDPOINTS_REF = {
    GET_CODIFICATIONS: '/codifications',
    GET_COUNTRIES: '/countries',

};
